import { parseRelativeDate } from '@/components/RunsTable/utils/getDateTimeRangeLabel';
import { useLocalStorageState } from '@/utils/use-local-storage-state';

export function useDefaultDuration(
  context?: 'runsTable' | 'conversationsList' | 'dashboard'
) {
  const [defaultDuration, setDefaultDuration] = useLocalStorageState(
    `ls:${context}:defaultDuration`,
    '7d'
  );
  if (!context) return { defaultDurationTimeModel: { duration: '7d' } };

  // Default duration hierarchy:
  // 1. use duration from query params in url (see: https://github.com/langchain-ai/langchainplus/blob/59fbb4ce77bb5c5f069fc7d29780ede9b1bbe6ac/smith-frontend/src/hooks/useDataGridState.tsx#L196)
  // 2. use default duration from local storage
  // 3. use 7d
  const parsedDefaultDuration = parseRelativeDate(defaultDuration);
  const relativeDefaultDuration = {
    duration: parsedDefaultDuration
      ? `${parsedDefaultDuration.value}${parsedDefaultDuration.unit}`
      : undefined,
  };
  return {
    defaultDurationTimeModel: relativeDefaultDuration ?? { duration: '7d' },
    defaultDuration,
    setDefaultDuration,
  };
}
